import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectRoute from './Protected.Routes';
import Layout from '../components/Sidebar/Layout';
import LayoutPOS from '../components/SidebarPos/LayoutPos.js';
import ProtectRoutePOS from './ProtectRoutePOS.js';
import Printer from '../components/Printer/Printer.js';

const LazyDashboard = lazy(() => import('../containers/Dashboard/Dashboard'));
const LazyDashboardMaster = lazy(() => import('../containers/Dashboard_Master/Dashboard'));
const LazyLogin = lazy(() => import('../containers/Login/Login'));
const LazyLoginMF = lazy(() => import('../containers/LoginMF/LoginMF.js'));
const LazySettings = lazy(() => import('../containers/Setting/Seting'));
const LazyAllUsers = lazy(() => import('../containers/RoleManagement/Register'));
const LazyRegionalMapping = lazy(() => import('../containers/RoleManagement/Table'));
const LazyRegisterItem = lazy(() => import('../containers/RegisterItem/RegisterItem'));
const LazyFoodDetails = lazy(() => import('../containers/FoodDetails/FoodDetails'));
const LazyStockDetails = lazy(() => import('../containers/StockDetails/StockDetails'));
const LazyTesting = lazy(() => import('../containers/Testing/Testing'));
const LazyRegisterCategory = lazy(() => import('../containers/RegisterCategory/RegisterCategory'));
const LazyFoodCategoryDetails = lazy(() => import('../containers/FoodCategoryDetails/FoodCategoryDetails'));
const LazyStockCategoryDetails = lazy(() => import('../containers/StockCategoryDetails/StockCategoryDetails'));
const LazyRegisterMF = lazy(() => import('../containers/MasterFranchise/RegisterMF'));
const LazyMasterFranchiseDetails = lazy(() => import('../containers/MasterFranchiseDetails/MasterFranchiseDetails'));
const LazyFranchiseDetails = lazy(() => import('../containers/FranchiseDetails/FranchiseDetails'));
const LazyRegisterFranchise = lazy(() => import('../containers/RegisterFranchise/RegisterFranchise'));
const LazySalesReports = lazy(() => import('../containers/SalesReports/SalesReports'));
const LazyOrderTacker = lazy(() => import('../containers/OrderTracker/OrderTracker'));
const LazyMFOrderTacker = lazy(() => import('../containers/MFOrderTracker/MfOrderTracker'));
const LazyOrderTackerMaster = lazy(() => import('../containers/OrderTrackerMaster/OrderTrackerMaster'));
const LazyOrderTackerSubAdmin = lazy(() => import('../containers/OrderTrackerSubAdmin/OrderTrackerSubAdmin.js'));
const LazyForgotPassword = lazy(() => import('../containers/ForgotPwd/ForgotPwd'));
const LazyNewPwd = lazy(() => import('../containers/NewPwd/NewPwd'));
const LazyProfile = lazy(() => import('../containers/Profile/Profile'));
const LazyNotification = lazy(() => import('../containers/Notification/Notification'));
const LazyNotificationShow = lazy(() => import('../containers/NotificationShow/NotificationShow'));
const LazyNotificationHistory = lazy(() => import('../containers/NotificationHistory/NotificationHistory'));
const LazyTrackTicket = lazy(() => import('../containers/TrackTicket/TrackTicket'));
const LazySupport = lazy(() => import('../containers/Supports/Support'));
const LazyCoupen = lazy(() => import('../containers/CoupenManager/CoupenManager.js'));
const LazyDiscount = lazy(() => import('../containers/DiscountCoupen/DiscountCoupen.js'));
const LazyCurrentStock = lazy(() => import('../containers/CurrentStock/CurrentStock.js'));
const LazyStockAdjust = lazy(() => import('../containers/StockAdjustMent/StockAdjustMent.js'));
const LazySalesReportsSubAdmin = lazy(() => import('../containers/SalesReportsSubAdmin/SalesReportsSubAdmin.js'));
const LazySalesReportsMF = lazy(() => import('../containers/SalesReportsMF/SalesReportsMF.js'));
const LazyFranchiseManager = lazy(() => import('../containers/FranchiseManager/FranchiseManager.js'));
const LazyFranchiseManagerRegister = lazy(() => import('../containers/FranchiseManagerRegister/FranchiseManagerRegister.js'));
const LazyCurrentStockMF = lazy(() => import('../containers/CurrentStockMF/CurrentStockMF.js'));
const LazyStockRequest = lazy(() => import('../containers/StockRequest/StockRequest.js'));
const LazyOrderPOS = lazy(() => import('../containers/OrderPOS/OrderPOS.js'));
const LazyOrderOverViewPOS = lazy(() => import('../containers/OrderOverViewPOS/OrderOverViewPOS.js'));
const LazyStockmanagePOS = lazy(() => import('../containers/StockManagementPOS/StockManagement.js'));
const LazyRequestHistoryPOS = lazy(() => import('../containers/RequestHistoryPOS/RequestHistory.js'));
const LazySalesReportPOS = lazy(() => import('../containers/SalesReportsPOS/SalesReportsPOS.js'));
const LazyDashboardPOS = lazy(() => import('../containers/DashboardPOS/Dashboard.js'));
const LazyNotificationPOS = lazy(() => import('../containers/NotificationShowPOS/NotificationShow.js'));
const LazyStockUnit = lazy(() => import('../containers/StockUnit/StockUnit.js'));
const LazyOfferImage = lazy(() => import('../containers/OfferImage/OfferImage.js'));
const LazyOfferRedeem = lazy(() => import('../containers/OfferRedeem/OfferRedeem.js'));
const LazyViewRoute = lazy(() => import('../containers/ViewRoute/ViewRoute.js'));
const LazyRouteAllocation = lazy(() => import('../containers/RootAllocationManager/RootAllocationManager.js'));
const LazyTempoManager = lazy(() => import('../containers/TempoManager/TempoManager.js'));
const LazyTempoRegister = lazy(() => import('../containers/TempoManagerDetails/TempoManagerDetails.js'));
const LazyCurrentStockPOS = lazy(() => import('../containers/CurrentStockPOS/CurrentStockPOS.js'));
const LazyCategoryAlarm = lazy(() => import('../containers/CategoryAlarm/CategoryAlarm.js'));
const LazyPaymentLimit = lazy(() => import('../containers/PaymentLimit/PaymentLimit.js'));
const LazyForceOrder = lazy(() => import('../containers/ForceOrder/ForceOrder.js'));
const LazyDynamicOffer = lazy(() => import('../containers/DynamicOffer/DynamicOffer.js'));
const LazyDynamicOfferPOS = lazy(() => import('../containers/DynamicOfferPOS/DynamicOfferPOS.js'));

const MyRoutes = () => {

  return (
    <Suspense fallback={<></>}>
      <Routes>

        <Route path="*" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LazyLogin />} />
        <Route path="/loginMF" element={<LazyLoginMF />} />
        <Route path="/forgot-password" element={<LazyForgotPassword />} />
        <Route path="/new-password/:token" element={<LazyNewPwd />} />
        
        {/* <Route path="/forgot-password" element={<LazyForgotPassword />} /> */}
        
<Route element={<ProtectRoutePOS />}>
      <Route element={<LayoutPOS />}>
         <Route path="/order-tracker/order-pos" element={<LazyOrderPOS />} />
         <Route path="/manage-stock/stockmanage-pos" element={<LazyStockmanagePOS />} />
         <Route path="/order-tracker/orderoverview-pos" element={<LazyOrderOverViewPOS />} />
         <Route path="/manage-stock/requesthistory-pos" element={<LazyRequestHistoryPOS />} />
         <Route path="/sales-report-pos" element={<LazySalesReportPOS />} />
         <Route path="/dashboard-pos" element={<LazyDashboardPOS />} />
         <Route path="/notification-pos" element={<LazyNotificationPOS />} />
            <Route path="/manage-stock/current-stockpos" element={<LazyCurrentStockPOS />} />
         <Route path="/offer/redeem" element={<LazyOfferRedeem />} />
         <Route path="/offer/dynamic-offer" element={<LazyDynamicOfferPOS />} />
          <Route path='/printer/printer' element={<Printer/>}></Route>
      </Route>
</Route>
         

        <Route element={<ProtectRoute isPrivate={true} />}>

        <Route element={<Layout />}>
          <Route path="/dashboard" element={<LazyDashboard />} />
          <Route path="/dashboard-master" element={<LazyDashboardMaster />} />
          <Route path="/settings" element={<LazySettings />} />
          <Route path="/role-management/register-user" element={<LazyAllUsers />} />
          <Route path="/role-management/table" element={<LazyRegionalMapping />} />
          <Route path="/item-details/register-item" element={<LazyRegisterItem />} />
          <Route path="/item-details/register-stock" element={<LazyRegisterItem type="stock" />} />
          <Route path="/item-details/register-food" element={<LazyRegisterItem type="food" />} />
          <Route path="/item-details/food" element={<LazyFoodDetails />} />
          <Route path="/item-details/stock" element={<LazyStockDetails />} />
          <Route path="/item-details/register-category" element={<LazyRegisterCategory />} />
          <Route path="/item-details/register-category-stock" element={<LazyRegisterCategory type="stock" />} />
          <Route path="/item-details/register-category-food" element={<LazyRegisterCategory type="food" />} />
          <Route path="/item-details/foods" element={<LazyFoodCategoryDetails />} />
          <Route path="/item-details/stocks" element={<LazyStockCategoryDetails />} />
          <Route path="/item-details/stock-unit" element={<LazyStockUnit/>} />
          <Route path="/franchise-manager/register-master-franchise" element={<LazyRegisterMF />} />
          <Route path="/franchise-manager/master-franchise-details" element={<LazyMasterFranchiseDetails />} />
          <Route path="/franchise-manager/franchise-details" element={<LazyFranchiseDetails />} />
          <Route path="/franchise-manager/register-franchise" element={<LazyRegisterFranchise />} />
          <Route path="/sales-reports" element={<LazySalesReports />} />
          <Route path="/order-tracker/franchise-order-tracker" element={<LazyOrderTacker />} />
          <Route path="/order-tracker/masterfranchise-order-tracker" element={<LazyMFOrderTacker />} />
          <Route path="/franachise-order-track" element={<LazyOrderTackerMaster />} />
          {/* <Route path="/subadmin-order-tracker" element={<LazyOrderTackerSubAdmin />} /> */}
          <Route path="/profile" element={<LazyProfile />} />
          <Route path="/test" element={<LazyTesting />} />
          <Route path="/offer/coupen-manager" element={<LazyCoupen />} />
          <Route path="/discount-coupen" element={<LazyDiscount />} />
          <Route path="/notification" element={<LazyNotification />} />
          <Route path="/notification-show" element={<LazyNotificationShow />} />
          <Route path="/notification-history" element={<LazyNotificationHistory />} />
          <Route path="/track-ticket" element={<LazyTrackTicket />} />
          <Route path="/stock-manager/current-stock" element={<LazyCurrentStock />} />
          <Route path="/stock-manager/stock-adjustment" element={<LazyStockAdjust />} />
          <Route path="/sales-reports-subadmin" element={<LazySalesReportsSubAdmin />} />
          <Route path="/sales-reports-MF" element={<LazySalesReportsMF />} />
          <Route path="/manage-franchise" element={<LazyFranchiseManager />} />
          <Route path="/manage-franchise-register" element={<LazyFranchiseManagerRegister />} />
          <Route path="/manage-stock/current-stockMF" element={<LazyCurrentStockMF />} />
          <Route path="/manage-stock/stock-request" element={<LazyStockRequest />} />
       
          <Route path="/offer/sidebar-image" element={<LazyOfferImage />} />
          <Route path="/offer/redeem" element={<LazyOfferRedeem />} />
          <Route path="route-manager/viewroute" element={<LazyViewRoute />} />
          <Route path="route-manager/route-allocation" element={<LazyRouteAllocation />} />
          <Route path="/tempo-manager" element={<LazyTempoManager />} />
          <Route path="/register-tempo" element={<LazyTempoRegister />} />

          <Route path="/support" element={<LazySupport />} />
          <Route path="/category-alarm" element={<LazyCategoryAlarm />} />
          <Route path="/payment-limit" element={<LazyPaymentLimit />} />
          <Route path="/force-order-franchise" element={<LazyForceOrder />} />
          <Route path="/dynamic-offer" element={<LazyDynamicOffer />} />
          
        </Route>
      </Route>
      </Routes>
    </Suspense>
  );
}

export default MyRoutes;
